"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getApi = exports.getConfig = exports.configureApi = void 0;
const axios_1 = __importDefault(require("axios"));
const config = {
    api: undefined // by default use axios as is
};
/**
 * Configures the MadConnect library axios instance.
 *
 * @param {AxiosInstance} api An axios instance with extra configurations like interceptors
 */
function configureApi(api) {
    config.api = api;
}
exports.configureApi = configureApi;
/**
 * Returns the config for the mad-connect library.
 *
 * @returns The Config
 */
function getConfig() {
    return config;
}
exports.getConfig = getConfig;
/**
 * Convenience function to return 'api' from the config.
 *
 * Returns either a custom axios instance configured by
 * the user via 'configureApi' or the default axios
 * implementation provided by the Axios library.
 *
 * @export
 * @returns {AxiosInstance} Either the default axios or the configured axios instance.
 */
function getApi() {
    return config.api ? config.api : axios_1.default;
}
exports.getApi = getApi;
